import { render, staticRenderFns } from "./referrer-timeline-follow-up.vue?vue&type=template&id=b28d9db4"
import script from "./referrer-timeline-follow-up.vue?vue&type=script&lang=js"
export * from "./referrer-timeline-follow-up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports